import { Component, OnInit, Input, ViewChild, EventEmitter, Output } from '@angular/core';
import { UtilService } from 'src/app/service/util.service';
import { Constants } from 'src/app/constants/constants';
import { ApiService } from 'src/app/service/api.service';
import { AuthenticationService } from 'src/app/service/authentication.service';
import { ToastService } from 'src/app/service/toast.service';
import { CardConnectComponent } from '../card-connect/card-connect.component';
import { isNullOrUndefined } from 'util';
import { NgForm } from '@angular/forms';
import { EnvService } from 'src/app/service/env.service';

@Component({
  selector: 'app-payment-options',
  templateUrl: './payment-options.component.html',
  styleUrls: ['./payment-options.component.scss']
})
export class PaymentOptionsComponent implements OnInit {

  @Input() invoice: any;
  @Input() accountPaymentSetting: any;

  paymentModel: any = null;
  paymentTypes: Array<string> = ["ACH", "CARD"];
  accountTypes: Array<string> = ["CHECKING_ACCOUNT"];//["CHECKING_ACCOUNT", "SAVINGS_ACCOUNT"];
  selectedAccountType: string = this.accountTypes[0];
  errorMessage: string;

  @ViewChild('cardConnect') cardConnect:CardConnectComponent;
  @Output() paymentStatusEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() backClickEmitter: EventEmitter<any> = new EventEmitter<any>();

  constructor(private apiService: ApiService, public authService: AuthenticationService, private utilService: UtilService, private toast: ToastService,
    private env: EnvService) { }

  ngOnInit() {
    this.initPaymentModel();
    this.initBillingAddressModel();
    this.getStateList();
  }

  initPaymentModel() {
    this.paymentModel = {
      "paymentType": this.paymentTypes[0],
      "autoPay": 'MANUAL',
      "savePaymentInstrument": false,
      "defaultPaymentMode": false
    };
  }

  async getTokenAndInitiatePayment(form: NgForm) {
    if (form.valid) {

      let payload = await this.getPaymentPayload();

      this.utilService.showSpinner();
      this.errorMessage = null;

      var count = 5;
      var intervalId = setInterval(() => {
        console.log("getting called.")
        if(count == 0) {
          this.utilService.hideSpinner();
          clearInterval(intervalId);
        }
        // If cardConnectEventData is still null/undefined then wait
        if(!isNullOrUndefined(this.cardConnect.cardConnectEventData)) {
          clearInterval(intervalId);
          console.log("getTokenAndInitiatePayment payload:", payload, "  cardConnectEventData:", this.cardConnect.cardConnectEventData);
          this.initiatePayment(payload);
        }
        count--;
      }, 500);
    }
  }

  initiatePayment(payload: any) {
    if(isNullOrUndefined(this.cardConnect.cardConnectEventData.token) || this.cardConnect.cardConnectEventData.token.trim().length == 0) {
      this.utilService.hideSpinner();
      this.errorMessage = this.cardConnect.cardConnectEventData.validationError;
      return;
    }
    
    payload["token"] = this.cardConnect.cardConnectEventData.token;
    if (this.paymentModel.paymentType == this.paymentTypes[1]) {
      payload['expiry'] = this.cardConnect.cardConnectEventData.expiry;
    }

    console.log("final payload::", payload);
    this.apiService.invoicePayment(payload).then((data) => {
      this.utilService.hideSpinner();
      this.cardConnect.cardConnectEventData = null;
      var emittingData = {
        "savedInstrument": this.paymentModel.savePaymentInstrument,
        "instrument" : data.instrument,
        "autoPay": this.paymentModel.autoPay
      }
      this.paymentStatusEmitter.emit(emittingData);
      document.getElementById("closePaymentModal").click();
      this.toast.showSuccess(data.status);
      console.log("payment response::", data);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.initiatePayment(payload);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }


  async getPaymentPayload() {
    console.log("getPaymentPayload() - cardConnectEvent Data:", this.cardConnect.cardConnectEventData);
    let payload = {
      "amount": this.invoice.invoiceSummary.total,
      "invoiceId": this.invoice.invoiceId,
      "mode": this.paymentModel.paymentType,
      "savePaymentInstrument": this.paymentModel.savePaymentInstrument,
      "defaultPaymentMode": this.paymentModel.savePaymentInstrument ? this.paymentModel.defaultPaymentMode : false,
      "accountHolderName": this.billingAddressModel.accountHolderName
    };
    if(this.paymentModel.paymentType == this.paymentTypes[0]) {
      payload['accountType'] = this.selectedAccountType;
    }

    payload['address'] = await this.getAddress();
    console.log("getPaymentPayload:", payload);
    return payload;
  }

  onChangePaymentType(event) {
    console.log(event, " EVENT")
    this.errorMessage = null;
    this.cardConnect.cardConnectEventData = null;
    this.billingAddressForm.reset();
    this.billingAddressForm.resetForm();
    setTimeout(() => {
      this.initBillingAddressModel();
    }, 500);
    this.paymentModel = {
      "paymentType": event,
      "autoPay": 'MANUAL',
      "savePaymentInstrument": false,
      "defaultPaymentMode": false
    };
  }

  resetFormData() {
    this.errorMessage = null;
    this.cardConnect.cardConnectEventData = null;
    this.billingAddressForm.reset();
    this.billingAddressForm.resetForm();
    setTimeout(() => {
      this.initBillingAddressModel();
    }, 500);
    this.initPaymentModel();
  }

  onBackClick() {
    this.backClickEmitter.emit();
  }

  /**
   * START: Billing Address changes
   */

  @ViewChild('billingAddressForm', { static: true }) public billingAddressForm: NgForm;

  billingAddressModel: any;
  invalidZipCode: boolean = false;
  stateList: Array<any> = new Array();
  addressTypes: Array<string> = ["Same as account address", "Same as billing address", "Other"];

   initBillingAddressModel() {
    this.billingAddressModel = {
      "accountHolderName": null,
      "address": {
        "street": null,
        "city": null,
        "zipCode": null,
        "state": null,
        "plus4Code": null,
        "country" : this.env.COUNTRY
      },
      "addressType": this.addressTypes[0]
    };

    this.invalidZipCode = false;
  }

  getZipCodeDetails(zipCode) {

    if (zipCode.length == 5) {
      this.apiService.getZipCodeDetails(zipCode).then((data) => {
        console.log("zip code detail data from api : ", data);
        this.invalidZipCode = false;
        this.billingAddressModel.address.state = data.places[0]["state abbreviation"];
        this.billingAddressModel.address.city = data.places[0]["place name"];

      }).catch((error) => {
        console.log("err : ", error);
        if (error.status == Constants.HTTP_NOT_FOUND) {
          this.invalidZipCode = true;
        } else if (error && error.error && error.error.message) {
          this.toast.showError(error.error.message);
        }
      });
    } else {
      this.invalidZipCode = false;
      this.billingAddressModel.address.state = null;
      this.billingAddressModel.address.city = null;
    }
  }

  getStateList() {
    this.apiService.getUsStateList().then((data) => {
      this.stateList = data;
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          console.log("refresh token api executed");
          this.getStateList();
        });
      }
      else {
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  async getAddress() {
    switch (this.billingAddressModel.addressType) {
      case this.addressTypes[0]:
        this.billingAddressModel.address = this.getAccountAddress();
        break;

      case this.addressTypes[1]:
        this.billingAddressModel.address = await this.getBillingAddress();
        break;
      case this.addressTypes[2]:
        // Do nothing since the address is already set to the model.
        break;
      default:
        this.billingAddressModel.address = null;
        break;
    }

    if (this.billingAddressModel.address && this.billingAddressModel.address.plus4Code == "") {
      this.billingAddressModel.address.plus4Code = null;
    }
    return this.billingAddressModel.address;
  }

  getAccountAddress(): any {
    let accountAddress = this.authService.accountData.contactPoints.addresses[0];
    return {
      "street": accountAddress.street,
      "city": accountAddress.city,
      "zipCode": accountAddress.postalCode,
      "state": accountAddress.state,
      "plus4Code": accountAddress.plus4Code,
      "country" : accountAddress.country
    };
  }

  async getBillingAddress() {
    try {
      let data = await this.apiService.getBillingProfile();
      console.log("billing data::", data)
      let billingAddress = data.address;
      return {
        "street": billingAddress.street,
        "city": billingAddress.city,
        "zipCode": billingAddress.zipCode,
        "state": billingAddress.state,
        "plus4Code": billingAddress.plus4Code,
        "country" : billingAddress.country
      };
    } catch (error) {
      this.errorMessage = "Unable to fetch the billing address.";
    }
  }

  /**
   * END: Billing Address changes
   */

}
